export const CATEGORIES = [
  { id: 1, label: "Véhicule et engins", image: "Véhicule.png" },
  { id: 2, label: "Logement", image: "Logement.png" },
  { id: 3, label: "Terrain", image: "Terrain.png" },
  { id: 10, label: "Formation", image: "Formation.png" },
  { id: 5, label: "Travail", image: "Travail.png" },
  //{ id: 4, label: "Rencontre", image: "Rencontre.png" },
  { id: 6, label: "Alimentation", image: "Alimentation.png" },
  { id: 12, label: "Plantes", image: "Plantes.png" },
  { id: 7, label: "Animaux", image: "Animaux.png" },
  { id: 9, label: "Équipement évènementiel", image: "Équipement évènementiel.png" },
  { id: 8, label: "Équipement de la maison", image: "Équipement de la maison.png" },
  { id: 11, label: "Matériaux et outillage", image: "Matériaux.png" },
  { id: 13, label: "Artisanat", image: "Artisanat.png" }
];
